import { getSettings } from '@/hooks/useSettings';
import wooCommerceStore from '@/stores/woocommerceStore';

export const trackEvent = (eventName, eventData) => {
  const { tracking } = getSettings();

  // Facebook Pixel
  if (tracking?.facebook_pixel?.enabled && window.fbq) {
    window.fbq('track', eventName, eventData);
  }

  // Google Analytics
  if (tracking?.google_analytics?.enabled && window.gtag) {
    window.gtag('event', eventName, eventData);
  }
};

export const trackAddToCart = (product, quantity) => {
  trackEvent('add_to_cart', {
    currency: wooCommerceStore.currency,
    value: product.price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: quantity,
    }],
  });
};

export const trackBeginCheckout = (cart) => {
  const value = cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  const items = cart.map(item => ({
    item_id: item.id,
    item_name: item.name,
    price: item.price,
    quantity: item.quantity,
  }));

  trackEvent('begin_checkout', {
    currency: wooCommerceStore.currency,
    value,
    items,
  });
};

export const trackViewItem = (product) => {
  trackEvent('view_item', {
    currency: wooCommerceStore.currency,
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
    }],
  });
};

export const trackViewItemList = (products) => {
  trackEvent('view_item_list', {
    items: products.map(product => ({
      item_id: product.id,
      item_name: product.name,
      price: product.price,
    })),
  });
};

export const trackViewCart = (cart) => {
  const value = cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  const items = cart.map(item => ({
    item_id: item.id,
    item_name: item.name,
    price: item.price,
    quantity: item.quantity,
  }));

  trackEvent('view_cart', {
    currency: wooCommerceStore.currency,
    value,
    items,
  });
};